interface Tab {
  key: string
  label: string
}

interface StatusTabsProps {
  activeTab: string
  tabs: Tab[]
  onTabChange: (key: string) => void
}

export function StatusTabs({ activeTab, tabs, onTabChange }: StatusTabsProps) {
  return (
    <div className="flex gap-1 h-[32px] bg-[#f0f0f0] p-1 rounded">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          className={`px-3 h-full flex items-center justify-center text-sm ${
            activeTab === tab.key
              ? 'bg-white text-gray-800 font-medium shadow-sm rounded'
              : 'text-gray-600'
          }`}
          onClick={() => onTabChange(tab.key)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  )
}
